module.exports = __webpack_public_path__ + "img/icone_atencao.ef3478ea.svg";